module.exports = __webpack_public_path__ + "static/media/Test.0d937ea3.jpg";